import React from 'react';
import { string } from 'prop-types';
import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

const propTypes = {
  id: string.isRequired
};
const Pilots = ({ id, heightSm }) => {
  const isMobile = window.innerWidth < 992;

  const pilotsProps = {
    header: 'Pilots',
    content:
      'Our high standard of safety means that every single pilot is a trained employee of JetSuite —no private' +
      ' contractors or third parties allowed. Every flight has two type-rated pilots and an average of over 8,000' +
      ' hours of flight time per crew member. Also, our required rest times surpass the industry standards' +
      ' prescribed by FAA’s Pilot Flight and Duty Time rules, ensuring that our crew and mechanics are prepared' +
      ' physically and mentally for every flight.'
  };

  return isMobile ? (
    <Mobile id={id} pilotsProps={pilotsProps} />
  ) : (
    <Desktop id={id} pilotsProps={pilotsProps} heightSm={heightSm} />
  );
};

Pilots.propTypes = propTypes;

export default Pilots;



// WEBPACK FOOTER //
// ./src/components/Safety/Pilots/Pilots.jsx